import { queueTrackingEvent } from '@library/tracking-integration'

export enum TrackingActions {
  CLICK_GET_STARTED = 'click_get_started',
  CLICK_GET_STARTED_STICKY_CTA = 'click_get_started_sticky_cta',
}

export enum Sections {
  HERO = 'carousel',
  STICKY_CTA = 'sticky_cta',
}

type CTAClickTrackingData = {
  action: TrackingActions
  properties: {
    section: Sections
  }
}

export function trackCTAClick(action: TrackingActions, homepageSection: Sections) {
  queueTrackingEvent<CTAClickTrackingData>({
    action,
    properties: {
      section: homepageSection,
    },
  })
}
